module.exports = __webpack_public_path__ + "img/package.4fd76816.svg";